import { IconButton, ListItem, styled } from '@mui/material';

import { elevationLevel } from '@/styles/constants';

export const ListActionItemContainer = styled(ListItem)<{ disabled?: boolean }>(
  ({ theme, disabled }) => ({
    border: '1px solid',
    borderColor: theme.palette.neutral[200],
    boxShadow: theme.shadows[elevationLevel.s],
    padding: theme.spacing(3, 2),
    borderRadius: theme.spacing(1),
    opacity: disabled ? 0.3 : 1,
    gap: theme.spacing(1.2),
    pointerEvents: disabled ? 'none' : 'auto',
    cursor: disabled ? 'default' : 'pointer',

    ':not(:last-of-type)': {
      marginBottom: theme.spacing(2),
    },

    '.MuiListItemText-root': {
      flex: 1,
    },

    '.MuiListItemButton-root': {
      flexGrow: 0,
      padding: 0,

      ':hover': {
        backgroundColor: 'transparent',
      },
    },
  }),
);

export const ActionButton = styled(IconButton)(({ disabled, theme }) => ({
  backgroundColor: theme.palette.primaries[200],
  padding: 4,
  minWidth: 0,
  pointerEvents: disabled ? 'none' : 'auto',
  borderRadius: 60,
}));
